import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import _ from 'lodash';

import { WidgetsContext } from './../core';
import { ParallaxProvider } from "react-scroll-parallax";

import styles from './landingPage.module.scss';


export function LandingPage({ children, onChange, pageWidgets }) {
  const widgetContext = React.useContext(WidgetsContext);
  const breakpoint = _.get(widgetContext, 'breakpoint');
  const selector = widgetContext.selector;

  const pageRef = React.useRef(null);

  const [state, setState] = useState({
    pageHeight: 0
  })

  const pageWidget = useSelector((state) => {
    const widgets = _.get(state, `${selector}.widgets`) || [];
    const page = widgets.find(item => item.uid == pageWidgets[0].uid);
    return page;
  });

  const pageHeight = _.get(pageWidget, `properties.${breakpoint}.layout.height`);
  const container = _.get(pageWidget, `properties.${breakpoint}.container`);

  React.useEffect(() => {
    var isInIframe = window.parent !== window;
    if (isInIframe) {
      const parentWindow = window.parent;
      parentWindow.postMessage({
        type: "cleverstory:embed:page:loading",
        payload: {
          pageWidget: pageWidget
        }
      }, '*'); 
    }
  },[]);

  React.useEffect(() => {
    if (pageWidgets && _.size(pageWidgets) > 0) {
      const windowWidth = document.body.clientWidth;
      var zoomValue = 1;
      if (widgetContext.shouldZoom) {
        zoomValue = windowWidth / container.minWidth;

        if (windowWidth > 1200) {
          zoomValue = 1;
        }
      }

      setState((state) => {
        return {
          ...state,
          pageHeight: `${(parseInt(pageHeight) * zoomValue)}px`
        }
      })
    }
  }, [pageWidgets, pageHeight, breakpoint]);

  useEffect(() => {
    if (pageRef && parseInt(state.pageHeight) > 0) {
      document.addEventListener('scroll', calculateScrollPosition);

      const clientHeight = document.body.clientHeight;
      if (clientHeight > parseInt(state.pageHeight)) {
        onChange('progress', {
          index: 0,
          progress: 100
        });
      }

      return () => {
        if (process.browser) {
          document.removeEventListener('scroll', calculateScrollPosition);
        }
      }
    }
  }, [state.pageHeight, pageRef]);

  const calculateScrollPosition = () => {
    const scrollTop = window.scrollY;
    const clientHeight = document.body.clientHeight;
    const scrollHeight = pageRef.current.scrollHeight;

    var percent = (scrollTop + clientHeight) * 100 / scrollHeight;
    percent = Math.max(0, percent);
    percent = Math.min(100, percent);

    onChange('progress', {
      index: 0,
      progress: percent
    });
  }

  var pageStyles = {
    height: state.pageHeight
  }

  return (
    <div className={styles.landingPage} style={pageStyles} ref={pageRef}>
      <ParallaxProvider>
        {children}
      </ParallaxProvider>
    </div>
  )
}
